import { AccountData, PassOrderPageData } from '../../api';
import { getOrderPage, getPassOrderPages } from '../../utils/AccountUtils';
import { LocationFilterValue } from './PassesFilterContext';

// Returns the single location id shared by all of a pass template's redeemable_on order pages,
// or null if the pages span multiple locations / none can be determined.
export const derivePassTemplateLocation = (account: AccountData, passTemplate: PassOrderPageData): string | null => {
  const items = passTemplate.redeemable_on;
  if (!items || items.length === 0) return null;

  const locationIds = new Set<string | undefined>();
  for (const item of items) {
    const op = getOrderPage(account, item.order_page_id);
    locationIds.add(op?.location_id);
  }

  if (locationIds.size !== 1) return null;
  const [only] = Array.from(locationIds);
  return only ?? null;
};

// Builds a map: pass_template_id -> derived location id (or null when undetermined).
export const buildPassTemplateLocationMap = (account: AccountData): Map<string, string | null> => {
  const templates = getPassOrderPages(account, true);
  const map = new Map<string, string | null>();
  for (const tpl of templates) {
    map.set(tpl.id, derivePassTemplateLocation(account, tpl));
  }
  return map;
};

export const templateIdsForLocations = (account: AccountData, locationIds: LocationFilterValue[]): string[] => {
  const locationMap = buildPassTemplateLocationMap(account);
  const selected = new Set(locationIds);
  return getPassOrderPages(account, true)
    .filter((tpl) => selected.has(locationMap.get(tpl.id) ?? null))
    .map((tpl) => tpl.id);
};
